import {
  GET_SCHOOL_LIST,
  GET_SCHOOL_LIST_SUCCESS,
  GET_SCHOOL_LIST_FAILURE,
  CREATE_SCHOOL,
  CREATE_SCHOOL_SUCCESS,
  CREATE_SCHOOL_FAILURE,
  VIEW_SCHOOL,
  VIEW_SCHOOL_SUCCESS,
  VIEW_SCHOOL_FAILURE,
  GET_TEACHER_LIST,
  GET_TEACHER_LIST_SUCCESS,
  GET_TEACHER_LIST_FAILURE,
  CREATE_TEACHER,
  CREATE_TEACHER_FAILURE,
  CREATE_TEACHER_SUCCESS,
  GET_STUDENT_LIST,
  GET_STUDENT_LIST_SUCCESS,
  GET_STUDENT_LIST_FAILURE,
  VIEW_STUDENT,
  VIEW_STUDENT_SUCCESS,
  VIEW_STUDENT_FAILURE,
  UPDATE_STATUS_SCHOOL,
  UPDATE_STATUS_SCHOOL_SUCCESS,
  UPDATE_STATUS_SCHOOL_FAILURE,
  DELETE_TEACHER,
  DELETE_TEACHER_SUCCESS,
  DELETE_TEACHER_FAILURE,
  UPDATE_STATUS_TEACHER,
  UPDATE_STATUS_TEACHER_SUCCESS,
  UPDATE_STATUS_TEACHER_FAILURE,
  VIEW_TEACHER,
  VIEW_TEACHER_SUCCESS,
  VIEW_TEACHER_FAILURE,
  UPDATE_TEACHER,
  UPDATE_TEACHER_SUCCESS,
  UPDATE_TEACHER_FAILURE,
  VIEW_SCHOOL_DETAILES,
  VIEW_SCHOOL_DETAILES_SUCCESS,
  VIEW_SCHOOL_DETAILES_FAILURE,
  EDIT_SCHOOL_SUCCESS,
  EDIT_SCHOOL,
  EDIT_SCHOOL_FAILURE,
  GET_COUNTRY_LIST,
  GET_COUNTRY_LIST_SUCCESS,
  GET_COUNTRY_LIST_FAILURE,
  GET_STATE_LIST,
  GET_STATE_LIST_SUCCESS,
  GET_STATE_LIST_FAILURE,
  GET_CITY_LIST_SUCCESS,
  GET_CITY_LIST_FAILURE,
  GET_CITY_LIST,

} from "../types";

export const getSchoolList = (payload) => ({
  type: GET_SCHOOL_LIST,
  payload,
});

export const getSchoolListSuccess = (payload) => ({
  type: GET_SCHOOL_LIST_SUCCESS,
  payload,
});

export const getSchoolListFailure = (payload) => ({
  type: GET_SCHOOL_LIST_FAILURE,
  payload,
});

export const createSchool = (payload) => ({
  type: CREATE_SCHOOL,
  payload,
});

export const createSchoolSuccess = (payload) => ({
  type: CREATE_SCHOOL_SUCCESS,
  payload,
});

export const createSchoolFailure = (payload) => ({
  type: CREATE_SCHOOL_FAILURE,
  payload,
});

export const viewSchool = (payload) => ({
  type: VIEW_SCHOOL,
  payload,
});

export const viewSchoolSuccess = (payload) => ({
  type: VIEW_SCHOOL_SUCCESS,
  payload,
});

export const viewSchoolFailure = (payload) => ({
  type: VIEW_SCHOOL_FAILURE,
  payload,
});

export const updateStatusSchool = (payload) => ({
  type: UPDATE_STATUS_SCHOOL,
  payload,
});

export const updateStatusSchoolSuccess = (payload) => ({
  type: UPDATE_STATUS_SCHOOL_SUCCESS,
  payload,
});

export const updateStatusSchoolFailure = (payload) => ({
  type: UPDATE_STATUS_SCHOOL_FAILURE,
  payload,
});

export const getTeacherList = (payload) => ({
  type: GET_TEACHER_LIST,
  payload,
});

export const getTeacherListSuccess = (payload) => ({
  type: GET_TEACHER_LIST_SUCCESS,
  payload,
});

export const getTeacherListFailure = (payload) => ({
  type: GET_TEACHER_LIST_FAILURE,
  payload,
});

export const createTeacher = (payload) => ({
  type: CREATE_TEACHER,
  payload,
});

export const createTeacherSuccess = (payload) => ({
  type: CREATE_TEACHER_SUCCESS,
  payload,
});

export const createTeacherFailure = (payload) => ({
  type: CREATE_TEACHER_FAILURE,
  payload,
});


export const deleteTeacher = (payload) => ({
  type: DELETE_TEACHER,
  payload,
});

export const deleteTeacherSuccess = (payload) => ({
  type: DELETE_TEACHER_SUCCESS,
  payload,
});

export const deleteTeacherFailure = (payload) => ({
  type: DELETE_TEACHER_FAILURE,
  payload,
});

export const updateStatusTeacher = (payload) => ({
  type: UPDATE_STATUS_TEACHER,
  payload,
});

export const updateStatusTeacherSuccess = (payload) => ({
  type: UPDATE_STATUS_TEACHER_SUCCESS,
  payload,
});

export const updateStatusTeacherFailure = (payload) => ({
  type: UPDATE_STATUS_TEACHER_FAILURE,
  payload,
});

export const viewTeacher = (payload) => ({
  type: VIEW_TEACHER,
  payload,
});

export const viewTeacherSuccess = (payload) => ({
  type: VIEW_TEACHER_SUCCESS,
  payload,
});

export const viewTeacherFailure = (payload) => ({
  type: VIEW_TEACHER_FAILURE,
  payload,
});

export const updateTeacher = (payload) => ({
  type: UPDATE_TEACHER,
  payload,
});

export const updateTeacherSuccess = (payload) => ({
  type: UPDATE_TEACHER_SUCCESS,
  payload,
});

export const updateTeacherFailure = (payload) => ({
  type: UPDATE_TEACHER_FAILURE,
  payload,
});

export const getStudentList = (payload) => ({
  type: GET_STUDENT_LIST,
  payload,
});

export const getStudentListSuccess = (payload) => ({
  type: GET_STUDENT_LIST_SUCCESS,
  payload,
});

export const getStudentListFailure = (payload) => ({
  type: GET_STUDENT_LIST_FAILURE,
  payload,
});

export const viewStudent = (payload) => ({
  type: VIEW_STUDENT,
  payload,
});

export const viewStudentSuccess = (payload) => ({
  type: VIEW_STUDENT_SUCCESS,
  payload,
});

export const viewStudentFailure = (payload) => ({
  type: VIEW_STUDENT_FAILURE,
  payload,
});


export const viewSchoolDetailes = (payload) => ({
  type: VIEW_SCHOOL_DETAILES,
  payload,
});

export const viewSchoolDetailessuccess = (payload) => ({
  type: VIEW_SCHOOL_DETAILES_SUCCESS,
  payload,
});

export const viewSchoolDetailesfailure = (payload) => ({
  type: VIEW_SCHOOL_DETAILES_FAILURE,
  payload,
});

export const editschool = (payload) => ({
  type: EDIT_SCHOOL,
  payload,
});

export const editschoolsuccess = (payload) => ({
  type: EDIT_SCHOOL_SUCCESS,
  payload,
});

export const editschoolfailure = (payload) => ({
  type: EDIT_SCHOOL_FAILURE,
  payload,
});

export const getCountryListSuccess = (payload) => ({
  type: GET_COUNTRY_LIST_SUCCESS,
  payload,
});

// Action creator for failed API response
export const getCountryListFailure = (payload) => ({
  type: GET_COUNTRY_LIST_FAILURE,
  payload,
});

// Action creator to initiate the API request
export const getCountryList = (payload) => ({
  type: GET_COUNTRY_LIST,
  payload ,
});

export const getStateList = (payload) => ({
  type: GET_STATE_LIST,
  payload ,
});

export const getStateListSuccess = (payload) => ({
  type: GET_STATE_LIST_SUCCESS,
  payload,
});

// Action creator for failed API response
export const getStateListFailure = (payload) => ({
  type: GET_STATE_LIST_FAILURE,
  payload,
});


export const getCityList = (payload) => ({
  type: GET_CITY_LIST,
  payload ,
});

export const getCityListSuccess = (payload) => ({
  type: GET_CITY_LIST_SUCCESS,
  payload,
});

// Action creator for failed API response
export const getCityListFailure = (payload) => ({
  type: GET_CITY_LIST_FAILURE,
  payload,
});


// Action creator to initiate the API request
